// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--2mgJ7","Text":"Text--27XF7","Title":"Title--28Ajg"};